import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStructuredDataBreadcrumbs from '../../../../hoc/withStructuredDataBreadcrumbs';

const Breadcrumbs = ({ breadcrumbs, textColor }) => (
    <div className="tw-hidden md:tw-block tw-py-2">
        <ul className="tw-flex">
            {breadcrumbs.map((breadcrumb, index) => (
                <li key={breadcrumb.path} className="tw-flex tw-items-center">
                    <Link to={breadcrumb.path} className={`tw-hover:underline ${textColor}`}>
                        {breadcrumb.label}
                    </Link>
                    {index < breadcrumbs.length - 1 && <span className="tw-mx-2">{'>'}</span>}
                </li>
            ))}
        </ul>
    </div>
);

Breadcrumbs.propTypes = {
    breadcrumbs: PropTypes.array.isRequired,
    textColor: PropTypes.string,
};

Breadcrumbs.defaultProps = {
    textColor: '',
};

export default withStructuredDataBreadcrumbs(Breadcrumbs);
